import {
  Component,
  OnInit,
  HostListener,
} from "@angular/core";
import { Subscription } from "rxjs";
import { User } from "../../../core/model/user";
import { PhysicianOptionService } from "../../shared/physician-option/physician-option.service";
import { PhysicianPractice } from "../../../core/model/v2/practitioner/physicianPractice";
import { GlobalHealthSystem } from "../../../core/model/v2/healthSystem/global-health-system";
import { AppointmentsService } from "../../appointments/appointments.service";
import { WindowLoaderService } from "src/app/shared/components/window-loader/window-loader.service";
import { CustomCalendarEvent } from "../../appointments/custom-models/custom-calendar-event";
import { ChatService } from "src/app/core/services/v2/chat.service";
import { ChatForUser } from "src/app/core/model/v2/chat/chat-for-user";
import { ReplyMessageComponent } from "../../chat/reply-message/reply-message.component";
import { MatDialog } from "@angular/material";
import { ChartDataSets, ChartOptions, ChartType } from "chart.js";
import { Label } from "ng2-charts";
import { PhysicianEventService } from "src/app/events/physician-event.service";

@Component({
  selector: 'app-old-dashboard',
  templateUrl: './old-dashboard.component.html',
  styleUrls: ['./old-dashboard.component.scss']
})
export class OldDashboardComponent implements OnInit {

   // firstName: string;
  // practitioner$: BehaviorSubject<Practitioner> = new BehaviorSubject(null);
  // practitionerId = 0;
  // photoUrlsend: string;
  // messages: string[] = [];
  // associatedPhysicians: Practitioner[] = [];
  // selectedPhysician: Practitioner;
  // referralsPatients: Appointment[] = [];
  // uniquePatentId: number[] = [];
  // physicianLogin: boolean = false;
  // physicianPractices: PhysicianPractice[] = [];
  // practSelectedLocation: PractitionerLocation;
  // practLocations: PractitionerLocation[] = [];
  // practSelectedLocationValues = [];
  // refreshSet: boolean;
  // refreshIntervalInSeconds: number = 60; //TBD - Need to be configured

  sideNavOpened = true;
  innerWidth: any;
  user: User;

  chatMessages: ChatForUser[];
  currentSelectedPhysicianUserId: number;
  todaysNewEvents: CustomCalendarEvent[] = [];

  selectedDate: Date = new Date();

  refreshPractId: number;
  refreshHsId: number;

  physicianSubscriber$: Subscription;
  //Chart
  public barChartOptions: ChartOptions = {
    responsive: true,
  };
  public barChartLabels: Label[] = [
    "2006",
    "2007",
    "2008",
    "2009",
    "2010",
    "2011",
    "2012",
  ];
  public barChartType: ChartType = "bar";
  public barChartLegend = true;
  public barChartPlugins = [];

  public barChartData: ChartDataSets[] = [
    { data: [65, 59, 80, 81, 56, 55, 40], label: "Series A" },
    { data: [28, 48, 40, 19, 86, 27, 90], label: "Series B" },
  ];
  //

  constructor(
    private physicianOptionService: PhysicianOptionService,
    private appointmentsService: AppointmentsService,
    private chatService: ChatService,
    private loaderService: WindowLoaderService,
    public dialog: MatDialog,
    private physicianEventService: PhysicianEventService
  ) {
    this.getScreenSize();
  }

  ngOnDestroy() {
    if (this.physicianSubscriber$) {
      this.physicianSubscriber$.unsubscribe();
    }
  }

  ngOnInit(): void {
    this.physicianSubscriber$ =
      this.physicianOptionService.selectionChange$.subscribe(
        (phy) => {
          if (phy) {
            this.currentSelectedPhysicianUserId =
              this.physicianOptionService.getPhysician().userId;
            this.appointmentsService.initAppointmentsService();
            this.physicianSelect(phy.selectedPhysician);
            this.locationSelect(phy.selectedHealthSystem);
            this.getAppointments();
            this.getChatMessages();
            this.physicianEventService.getevents();
          }
        },
        (error) => {
          console.error(error);
        }
      );
  }

  physicianSelect(selected: PhysicianPractice) {
    this.refreshPractId = selected.id;
  }

  locationSelect(loc: GlobalHealthSystem) {
    this.refreshHsId = loc.id;
  }

  getAppointments(): void {
    this.loaderService.show();
    this.appointmentsService.getCalendarAppointments().subscribe(
      (_) => {
        this.appointmentsService.setSelectedDayEvents(this.selectedDate);
        this.todaysNewEvents =
          this.appointmentsService.getTodaysNewAppointments();
        this.appointmentsService.refreshCalendar.next();
        this.loaderService.hide();
      },
      (error) => {
        console.error(error);
        this.loaderService.hide();
      }
    );
  }

  getChatMessages(): void {
    this.loaderService.show();
    this.chatService
      .getReceivedChat(this.physicianOptionService.getPhysician().userId)
      .subscribe(
        (ret) => {
          this.chatMessages = ret
            .filter((x) => !x.read)
            .sort((a, b) => (a.date > b.date ? -1 : 1));
        },
        (error) => {
          console.error(error);
          this.loaderService.hide();
        }
      );
  }

  markMessageAsRead(messageId: number): void {
    this.loaderService.show();
    this.chatService.markAsRead(messageId).subscribe(
      (ret) => {
        const currentMessage = this.chatMessages.find(
          (x) => x.chatMessageId === messageId
        );
        currentMessage.read = true;

        this.chatMessages = this.chatMessages
          .filter((x) => !x.read)
          .sort((a, b) => (a.date > b.date ? -1 : 1));
        this.loaderService.hide();
      },
      (error) => {
        console.error(error);
        this.loaderService.hide();
      }
    );
  }

  toggleSideNav() {
    this.sideNavOpened = !this.sideNavOpened;
  }

  @HostListener("window:resize", ["$event"])
  getScreenSize(event?) {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth > 784) this.sideNavOpened = true;
    else this.sideNavOpened = false;
  }

  selectDate(event) {
    this.selectedDate = event;
    this.appointmentsService.setSelectedDayEvents(event);
  }

  replyMessage(chat: ChatForUser): void {
    this.dialog.open(ReplyMessageComponent, {
      id: "replyMessage",
      width: "50%",
      data: chat,
    });
  }

  //Events

  ///
}
